import { RoundedModal } from "@/components/modal/rounded-modal";
import { FilledButton, TextButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface UserDetailSuccessModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  firstName: string;
  onConfirm: () => void;
  onEdit?: () => void;
}

export const UserDetailSuccessModal = memo(function UserDetailSuccessModal({
  isOpen,
  onDismiss,
  firstName,
  onConfirm,
  onEdit,
}: UserDetailSuccessModalProps) {
  return (
    <RoundedModal isOpen={isOpen} onDidDismiss={onDismiss} backdropDismiss={true}>
      <div className="flex flex-col items-center px-4 pt-0 pb-3">
        <div className="relative h-[146px] w-[216px] bg-[url('/assets/images/dots-bg.svg')] bg-center bg-no-repeat">
          <div className="absolute top-1/2 left-1/2 flex h-[84px] w-[84px] -translate-x-1/2 -translate-y-1/4 items-center justify-center rounded-full border-2 border-white bg-white shadow-[0px_0px_12px_0px_rgba(0,0,0,0.12)]">
            <div className="absolute inset-0 rounded-full shadow-[inset_0px_6px_12px_0px_rgba(0,0,0,0.12)]" />
            <span className="relative z-10 text-[38px] leading-none">👋🏻</span>
          </div>
        </div>

        <h2 className={cn(textVariants.title2, "mb-9 text-center")}>Hi, {firstName}!</h2>

        <p className={cn(textVariants.bodySingleLine, "mb-11 text-center")}>
          Welcome! This will feel easier than anything you’ve tried before.
        </p>

        <div className="w-full space-y-3">
          <FilledButton text="GOT IT!" color="black" onClick={onConfirm} />

          <TextButton color="black" underline onClick={onEdit}>
            Edit name
          </TextButton>
        </div>
      </div>
    </RoundedModal>
  );
});
